import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router:Router){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('accessToken')!=null)
    {
      return true;
    } 
    // not logged in so redirect to login page with the return url   
    this.router.navigate(['/login'])
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts